import Phaser from 'phaser'

import Preloader from './scenes/Preloader'
import StartScreen from './scenes/StartScreen'
import Game from './scenes/Game'
import GameOver from './scenes/GameOver'
import HighScores from './scenes/HighScores'

// Initialize Firebase (must be imported before any scenes use it)
import './config/firebase'

console.log('🚀 MAIN.TS LOADED - GAME STARTING')
console.log('🚀 Firebase module imported')

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  scale: {
    mode: Phaser.Scale.FIT,
    parent: 'game-container',
    width: 1280,
    height: 720,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 500 },
      debug: false,
    },
  },
  audio: {
    disableWebAudio: false,
    noAudio: false,
    context: undefined, // Let Phaser create the context
    // Limit simultaneous sounds to prevent audio glitching
  },
  scene: [Preloader, StartScreen, Game, GameOver, HighScores],
}

export default new Phaser.Game(config)
